import { render } from "./Champion.vue?vue&type=template&id=cca8d44a&scoped=true"
import script from "./Champion.vue?vue&type=script&lang=ts"
export * from "./Champion.vue?vue&type=script&lang=ts"

import "./Champion.vue?vue&type=style&index=0&id=cca8d44a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cca8d44a"

export default script